export const environment = {
  production: true,
  webservice: 'https://webservice.economico.dev.eng.c-alm.ch',
  clientName: 'MarketIFrame',
  clientOrigin: 'https://marketframe.economico.dev.eng.c-alm.ch',
  iframeParentOrigin: 'https://finport.dev.eng.c-alm.ch'
};
